import {
  Grid,
  Skeleton,
  VerticalBox,
} from "@inductiveautomation/ws-components";

const ProfileFormLoading = () => (
  <VerticalBox gap="1.5rem">
    <Grid container spacing="1rem">
      <Grid size={{ xs: 12, sm: 6 }}>
        <Skeleton variant="form_field" count={1} />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Skeleton variant="form_field" count={1} />
      </Grid>
    </Grid>

    <Skeleton variant="form_field" count={2} />
  </VerticalBox>
);

export default ProfileFormLoading;
